import { CUSTOMER_ANALYTICS_URLS } from '~/constants/customers'

export const getCustomerAnalyticsUrl = (
  customerName?: string | null
): string | null => {
  if (!customerName) {
    return null
  }

  return CUSTOMER_ANALYTICS_URLS[customerName] ?? null
}
